module["exports"] = [
  "#{street_name} #{building_number}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/street_address.js
 ** module id = 1023
 ** module chunks = 0
 **/